// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"9e7ae57f","39":"e0d647f4","93":"c3edab22","472":"1613a1d9","520":"5fa6bd20","611":"3cd29f54","685":"f92def76","723":"43f31ec7","747":"0740aeaf","822":"decbfec6","932":"2a66e4cb"}[chunkId] + ".chunk.js";
};